import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import MDUserProfileHeader from './MDUserProfileHeader';
import "../Styles/CustomerManagement.css";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloudProHeader from './CloudProHeader';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
const CloudProMDManagement = () => {
    const [users, setUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { mdId } = useParams();

    const roleMap = {
        1: 'Admin',
        2: 'Tech',
    };

    const userStatusMap = {
        1: 'Pending Approval',
        2: 'Pending Activation',
        3: 'Activated',
        4: 'Deleted'
    };

    const formatFetchedUsers = (users) => {
        return users.map(user => ({
            ...user,
            role: roleMap[user.role] || user.role,
            status: userStatusMap[user.status] || user.status
        }));
    };

    const fetchUsers = () => {
        Axios.post(`/get_MD_customers`, { mdId }).then((response) => {
            if (response.data.success) {
                setUsers(formatFetchedUsers(response.data.data));
            } else {
                toast.error("Failed to get all users.", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        });
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleSelectUser = (userEmail) => {
        setSelectedUsers((prev) => {
            if (prev.includes(userEmail)) {
                return prev.filter((email) => email !== userEmail);
            } else {
                return [...prev, userEmail];
            }
        });
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedUsers([]);
        } else {
            setSelectedUsers(users.map(user => user.email));
        }
        setSelectAll(!selectAll);
    };

    const handleDeleteUsers = () => {
        Axios.post(`/delete_users`, { emails: selectedUsers }).then((response) => {
            if (response.data.success) {
                toast.success(`${response.data.msg}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
            fetchUsers();
            setSelectedUsers([]);
            setOpenDialog(false);;
        });
    };

    const handleBack = () => {
        console.log("Back button clicked!");
        console.log("Current path:", location.pathname);
        // Dismiss any active toasts before navigating
        toast.dismiss();
        // Check if we can go back in history
        if (window.history.state && window.history.state.idx > 0) {
            navigate(-1);  // Go back one step in history
            console.log("Navigating back one step.");
        } else {
            // If no history, navigate to the dashboard without adding an entry
            navigate('/dashboard', { replace: true });
            console.log("No history to go back, redirecting to dashboard.");
        }
    };

    return (
        <>
 
            <CloudProHeader isAdmin={true} />

            <div className="glass-card">

                <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                        <div className="header">
                            <div className="left-actions">
                                 <h6>Master Distributor User List</h6>
                            </div>
                            <div className="right-actions">
                                <div className="button-row">
                                    <button onClick={fetchUsers} className="refresh-button">Refresh</button>
                                    <button onClick={handleBack} disabled={true} className="save-button">Edit</button>
                                    <button
                                        onClick={() => setOpenDialog(true)}
                                        className="delete-button"
                                        disabled={selectedUsers.length === 0}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                                <table className="project-table">

                                    <thead>
                                        <tr>
                                            <th>
                                                <input
                                                    type="checkbox"
                                                    checked={selectAll}
                                                    onChange={handleSelectAll}
                                                />
                                            </th>
                                            <th>Order</th>
                                            <th>First Name</th>
                                            <th>Last Name</th>
                                            <th>Email</th>
                                            <th>Customer ID</th>
                                            <th>VELOX Cloud Key Serial Number</th>
                                            <th>Role</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users.map((user, index) => (
                                            <tr key={user.email}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedUsers.includes(user.email)}
                                                        onChange={() => handleSelectUser(user.email)}
                                                    />
                                                </td>
                                                <td>{index + 1}</td>
                                                <td>{user.first_name}</td>
                                                <td>{user.last_name}</td>
                                                <td>{user.email}</td>
                                                <td>{user.customer_id || "-"}</td>
                                                <td>{user.key_serial_number}</td>
                                                <td>{user.role}</td>
                                                <td>{user.status}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                      
                    </CardContent>
                </Card>
            </div>

            <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Delete Users"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Do you want to delete these users?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteUsers} color="primary">Yes</Button>
                    <Button onClick={() => setOpenDialog(false)} color="secondary" autoFocus>No</Button>
                </DialogActions>
            </Dialog>


            <ToastContainer />
        </>
    );

};

export default CloudProMDManagement;
